module.exports = __webpack_public_path__ + "img/itrain-holder.cfb78fc9.png";